import { Schema } from '@core/data/dto/schema';
import { getLocalMomentFromISO } from '@core/utils/date-time';

export const EmployeeWageSchema = {
    id: Schema.String,
    wage_type: Schema.String,
    effective: Schema.Moment,
    salary: {
        map: 'salary',
        mapImport: (value) => {
            if (value) {
                return {
                    amount: value.amount || 0,
                    hours: value.hours || 0
                }
            } else {
                return null;
            }
            
        }
    },
    approved_by: {
        map: 'approvedBy',
        mapImport: (value) => {
            if (value) {
                return {
                    id: value.id,
                    name: value.name
                }
            } else {
                return null;
            }
        }
    },
    approved_at: {
        map: 'approvedAt',
        mapImport: (value: string) =>
            getLocalMomentFromISO(value),
    },
}